import { PinInputField } from '@chakra-ui/pin-input';
import styled from '@emotion/styled';
import { disabledStyles } from '@lbcamden/lib-react';

export const PinInputRoot = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const DigitInput = styled(PinInputField)`
  ${({ theme }) => theme.text.lead}

  padding: ${({ theme }) => theme.spacing(1)};
  font-family: monospace;
  text-align: center;
  border: 2px solid ${({ theme }) => theme.colors.text};
  border-radius: 0;

  &:focus {
    outline: 3px solid ${({ theme }) => theme.colors.highlight};
  }

  &:disabled,
  &:read-only {
    ${disabledStyles}
  }
`;
